if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.images-slides figure').attr('aria-hidden', false);

    $('.reviews-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 500,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                    autoplay: false,
                }
            }
        ]
    });

    $('.carousel-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        accessibility: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-info').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
    });

    $('.images-single').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    variableWidth: false,
                    slidesToShow: 1,
                    dots: true,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 44;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 44;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 44;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
    });

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a#js_btn_book,a.btn-check))").click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

    let screenHeight = $(window).height();
    $('#home .top-img figure, #home .top-img video').css("height", screenHeight - 100);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('#home .top-img figure, #home .top-img video').css("height", screenHeight -100);
    });

    /** Booking Offer */
    const bookingOffer = document.querySelectorAll('.bookingOffer');
    bookingOffer.forEach(room=>{
        const promoCode = room.dataset.promo;
        if(promoCode.length>0){
            room.addEventListener('click',function(e){
                e.preventDefault()
                window.location.hash = `#/booking/step-1?promo=${promoCode}`;
            })
        }
    })
    /** Booking Room */
    const  bookingRoom = document.querySelectorAll('.bookingRoom');
    bookingRoom.forEach(room=>{
        const promoCode = room.dataset.promo;
        if(promoCode.length>0){
            room.addEventListener('click',function(e){
                e.preventDefault()
                window.location.hash = `#/booking/step-1?room=${promoCode}`;
            })
        }
    })

    /** Booking Home */
    const bookingHome = document.getElementById('bookingHome');
    if(bookingHome){
		bookingHome.addEventListener('click', function(e){
			e.preventDefault();
			let hashes   = '#/booking/step-1',
                params  = [],
                rooms   = document.getElementById('rooms').value,
                adults  = document.getElementById('adults').value,
                arrive  = document.getElementById('arriveInputHome').value.replace(/-/g,'/'),
                depart  = document.getElementById('departureInputHome').value.replace(/-/g,'/');
                

            if (rooms > 0)
                params.push(`rooms=${rooms}`);
            
            if (adults > 0)
               params.push(`adults=${adults}`);

            if (arrive.length >0)
               params.push(`arrive=${arrive}`);

            if (depart.length > 0)
               params.push(`depart=${depart}`);

            if(params.length==0){
                window.location.hash = hashes
            }else{
                window.location.hash = `${hashes}?${params.join('&')}`
            }
		});
	}

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#navigationBox');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('#navigationBox .privary-navigation__item a, #navigationBox .secondary-navigation__item a');


    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}
    document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();


    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#navigationBox');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});

/** ADA Keyboard Navigation Functionality for the Dropdown Widget **/
document.addEventListener('DOMContentLoaded', () => {
	const dropdownWrapper = document.getElementById('dropdown-js');
	const dropdownButton = dropdownWrapper.querySelector('.btn-dropdown');
	const dropdownMenu = dropdownWrapper.querySelector('.dropdown__hover');
	const menuLinks = dropdownMenu.querySelectorAll('a');
    const bookingSelect = document.getElementById('rooms');

	dropdownButton.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			dropdownButton.classList.add('active');
			dropdownButton.setAttribute('aria-expanded', 'true');
			if (menuLinks.length) {
				menuLinks[0].focus();
			}
		}
	});

	dropdownWrapper.addEventListener('focusout', () => {
		setTimeout(() => {
			if (!dropdownWrapper.contains(document.activeElement)) {
				dropdownButton.classList.remove('active');
				dropdownButton.setAttribute('aria-expanded', 'false');
			}
		}, 0);
	});
});

document.addEventListener('DOMContentLoaded', function () {
    const skipLink = document.querySelector('a[href="#intro"]');
    const mainContent = document.getElementById('intro');


    if (skipLink && mainContent) {
        skipLink.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            mainContent.setAttribute('tabindex', '-1');
            mainContent.focus();
            }
        });
    }
});




